import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'
import { catchError, Observable, tap } from 'rxjs'
import { HttpServiceHelper } from '../common/http-service-helper'
import { HttpClient } from '@angular/common/http'

@Injectable({
    providedIn: 'root',
})
export class SrecFormService {
    // call to azure function - url saved in environment
    private requestUrl = `${environment.srecApiUrl}`

    constructor(
        private _httpHelper: HttpServiceHelper,
        private http: HttpClient
    ) {}

    postSrecForm(formData: FormData): Observable<FormData> {
        // automatically sets to multipart/form-data content type without explicit set
        return this._httpHelper.httpPostFormNoAuth<FormData>(
            this.requestUrl + '/register',
            formData
        )
    }

    postIneligibleRegistration(formData: FormData): Observable<any> {
        // automatically sets to multipart/form-data content type without explicit set
        return this._httpHelper.httpPostFormNoAuth<any>(
            this.requestUrl + '/ineligibleRegister',
            formData
        )
    }

    getClientIPAddress(): Observable<any> {
        return this.http.get<any>('https://geolocation-db.com/json/').pipe(
            catchError((err) => {
                return err
            }),
            tap((response) => {
                return response.IPv4
            })
        )
    }
}
